module.exports = __webpack_public_path__ + "static/media/uppvarmning_1366.86c4be8f.jpg";